import React, { Component } from "react";
import FramesItems from "../Components/Frames/FramesItems";
import Constants from '../Config/Config';

class Frames extends Component {

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 100,
      productsLaoded: false,
      error: null,
      frameProducts: [],
      runAPI: false
    }
  }

  fetchProducts = (category) => {
    this.setState({ runAPI: true });
    var self = this;
    const page = this.state.page;
    const per_page = this.state.limit;
    if (this.state.productsLaoded)
      this.setState({productsLaoded: false});
    const URL = Constants.URL.root+'/webservices/getProductsWC.php';
    fetch(URL+'?page='+page+'&per_page='+per_page+'&category='+category)
    .then(response => {
      if (!response.ok) {
        throw Error('Network request failed.')
      }
      return response;
    })
    .then(data => data.json())
    .then(data => {
      //console.log(data);
      var resultfinal = self.state.frameProducts.concat(data);

      resultfinal.sort(function(a, b) {
        return parseFloat(a.dimensions.width) - parseFloat(b.dimensions.width);
      })

      self.setState({
        productsLaoded: true,
        frameProducts: resultfinal,
      });
      self.dispatchFramesData(resultfinal);
    }, (ex) => {
      //self.setState({ error: err.message });
      console.log('error in API for frames')
      this.fetchProducts(category);
    })
  }

  selectFrame = (product) => {
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        selectedFrame: product,
        frameLoading: false
      }
    })
  };

  dispatchFramesData(FramesData) {
    const data = FramesData;
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        frameProducts: data
      }
    })
  }

  fetchFrameCalc() {
    var self = this;
    fetch(Constants.URL.root+'/wp-json/acf/v2/options')
    .then(response => {
      if (!response.ok) {
        throw Error('Network request failed.')
      }
      return response;
    })
    .then(data => data.json())
    .then(data => {
      //console.log(data);
      self.dispatchFramesCalc(data);
    }, (ex) => {
      console.log('error in API for fetchFrameCalc')
      this.fetchFrameCalc();
    })
  }

  dispatchFramesCalc(data) {
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        framedCalc: data
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if ('frames' === this.props.selectedTab && !this.state.runAPI) {
      this.fetchFrameCalc();
      this.fetchProducts(46);
    }
  }

  render() {
    //console.log(this.state.products)
    return (
      <FramesItems
        {...this.props}
        productsLaoded={this.state.productsLaoded}
      />
    );
  }
}
export default Frames;